<script>
    let className = '';
    export {className as class};
    export let id;

</script>

<style>
    .one-px-table-border {
        border: 1px solid #bbb;
    }
</style>

<table class={`table ${className}`} {id}>
    <slot></slot>
</table>